<template>
    <div class="top-priorities">
      <div v-if="priorities.length > 0">
        <priority-item v-for="priority in priorities" :key="priority.id" :priority="priority" />
      </div>
      <div v-else class="top-priorities-empty">
        <div>
          <priorities-empty />
        </div>
        <div class="mt-2">
          No priorities… yet!
        </div>
      </div>
    </div>
</template>

<script>
import PriorityItem from './PriorityItem'
import PrioritiesEmpty from '@/assets/images/priorities-empty.svg'

export default {
  name: 'TopPriorities',

  props: {
    priorities: {
      type: Array,
      default: () => ([])
    }
  },

  components: {
    PrioritiesEmpty,
    PriorityItem
  }
}
</script>
